export interface StatsPillProps {
  label: string;
  value: string | number;
  className?: string;
}

export function StatsPill({ label, value, className = '' }: StatsPillProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-2xl px-2 py-1.5 flex-1 ${className}`}
      style={{
        backgroundColor: '#E6F4FF',
        border: '2px solid black'
      }}
    >
      <span
        className="font-mind-boggle leading-tight text-center"
        style={{
          fontSize: 'clamp(0.5rem, 2.5vw, 0.7rem)',
          color: '#1A3A5C'
        }}
      >
        {label}
      </span>
      <span
        className="font-mind-boggle leading-tight text-center"
        style={{
          fontSize: 'clamp(0.625rem, 3vw, 0.875rem)',
          color: '#1A3A5C'
        }}
      >
        {value}
      </span>
    </div>
  );
}

export default StatsPill;
